module.exports = __webpack_public_path__ + "static/media/react.df70b005.png";